<template>
	<div>
		
		<div class="ng-faq">
			<div class="w1100">
				<ul class="ng-help-ul">
					<li class="ng-help-li">
						<span class="ng-help-span">新手入门</span>
						<ul class="ng-help-list">
							<li><a :href="`${CurrentEnvPrefix.main}${Common.getSourec().sitehost}/shop/index.php`" target="_blank'">登录注册</a></li>
							<li><a :href="`${CurrentEnvPrefix.main}${Common.getSourec().sitehost}/shop/index.php?act=article&op=show&article_id=797`" target="_blank">支付方式</a></li>
							<li><a :href="`${CurrentEnvPrefix.main}${Common.getSourec().sitehost}/shop/index.php?act=article&op=show&article_id=795`" target="_blank">新手下单流程</a></li>
							<li><a :href="`${CurrentEnvPrefix.main}${Common.getSourec().sitehost}/shop/index.php?act=article&op=show&article_id=1595`" target="_blank">关于我们</a></li>
							<li><a :href="`${CurrentEnvPrefix.main}${Common.getSourec().sitehost}/shop/index.php?act=article&op=show&article_id=1593`" target="_blank">联系我们</a></li>
							<li><a :href="`${CurrentEnvPrefix.main}${Common.getSourec().sitehost}/shop/index.php?act=article&op=show&article_id=1591`" target="_blank">招聘英才</a></li>
						</ul>
					</li>
					<li class="ng-help-li">
						<span class="ng-help-span">店主之家</span>
						<ul class="ng-help-list">
							<li><a :href="`${CurrentEnvPrefix.main}${Common.getSourec().sitehost}/shop/index.php?act=article&op=show&article_id=11`" target="_blank">如何管理店铺</a></li>
							<li><a :href="`${CurrentEnvPrefix.main}${Common.getSourec().sitehost}/shop/index.php?act=article&op=show&article_id=671`" target="_blank">QQ无法跳转</a></li>
							<li><a :href="`${CurrentEnvPrefix.main}${Common.getSourec().sitehost}/shop/index.php?act=article&op=show&article_id=813`" target="_blank">电商城最"惠"招商</a></li>
						</ul>
					</li>
					<li class="ng-help-li">
						<span class="ng-help-span">售后服务</span>
						<ul class="ng-help-list">
							<li><a :href="`${CurrentEnvPrefix.main}${Common.getSourec().sitehost}/shop/index.php?act=article&op=show&article_id=809`" target="_blank">快递查询</a></li>
							<li><a :href="`${CurrentEnvPrefix.main}${Common.getSourec().sitehost}/shop/index.php?act=article&op=show&article_id=26`" target="_blank">联系卖家</a></li>
						</ul>
					</li>
					<li class="ng-help-li">
						<span class="ng-help-span">特色功能</span>
						<ul class="ng-help-list">
							<li><a :href="`${CurrentEnvPrefix.main}${Common.getSourec().sitehost}/shop/index.php?act=article&op=show&article_id=469`" target="_blank">APP使用手册</a></li>
							<li><a :href="`${CurrentEnvPrefix.main}${Common.getSourec().sitehost}/shop/index.php?act=article&op=show&article_id=803`" target="_blank">微商神器</a></li>
							<li><a :href="`${CurrentEnvPrefix.main}${Common.getSourec().sitehost}/shop/index.php?act=article&op=show&article_id=1367`" target="_blank">纺支宝代发说明</a></li>
							<li><a :href="`${CurrentEnvPrefix.main}${Common.getSourec().sitehost}/shop/index.php?act=article&op=show&article_id=1033`" target="_blank">如何一键上传</a></li>
						</ul>
					</li>
				</ul>
				<div class="ng-help">
					<div class="contact-border">
						<!-- <div class="help-app">
							<img src="http://www.fangzhibao.com/shop/templates/default/images/1.jpg">
							<img :src="'http://www.fangzhibao.com/shop/templates/default/images/'+setsearch.logowx">
							<p>纺支宝App</p>
						</div>
						<div class="help-app" style="margin-left:35px;">
							<img src="http://www.fangzhibao.com/shop/templates/default/images/1.jpg">
							<p>微信公众号</p>
						</div> -->
						<p class="help-tel">{{setsearch.phone}}</p>
						<p class="help-mail">{{setsearch.email}}</p>
					</div>
				</div>
			</div>
		</div>
		<div class="ng-footer">
			<div class="w1200">
				<!-- <p>
					<a href="#">首页</a>
					<span>|</span>
					<a href="#">招聘英才</a>
					<span>|</span>
					<a href="#">联系我们</a>
					<span>|</span>
					<a href="#">关于我们</a>
					<span>|</span>
					<a href="#">友情链接</a>
				</p> -->
				<p v-html="setsearch.code">{{setsearch.code}}</p>
				<p></p>
				<p></p>
			</div>
		</div>
	</div>
</template>


<script>

import HtmlUtil from '../../global/js/htmldecode.js';
import {CurrentEnvPrefix} from 'config/urlprefix.js'
export default {
  	data () {
    	return {
    		setsearch:[],
				CurrentEnvPrefix
    	}
  	},
    methods: {
    	getSetSearch(){
    		var _this = this;
    		setTimeout(function(){
	    		var site = _this.Common.getSourec().site;
	    		let set=[];
	            if(site){
	            	set.code = HtmlUtil.htmlDecode(site.statistics_code.value);
	            	set.email = site.site_email.value;
	            	set.phone = site.site_phone.value;
	            	set.logowx = site.site_logowx.value;
	            }
	            _this.setsearch = set;
	        },500);
    	},
    },
    mounted(){
    	this.getSetSearch();
    }
}
</script>


// WEBPACK FOOTER //
// src/components/public/footer.vue